import { ListingExternalTourType } from '@zg-rentals/ts-rental-manager-api-beta-client';

/**
 * Maps backend display strings to API enum values.
 * Backend returns human-readable display strings like "Integration", "Feed Provided", "ZRM"
 * but the API requires uppercase enum values like "INTEGRATION", "FEED_PROVIDED", "ZRM"
 */
export const TOUR_TYPE_DISPLAY_TO_ENUM: Record<string, ListingExternalTourType> = {
  Integration: ListingExternalTourType.INTEGRATION,
  'Feed Provided': ListingExternalTourType.FEED_PROVIDED,
  ZRM: ListingExternalTourType.ZRM,
};

export const mapTourTypeDisplayToEnum = (displayValue?: string): ListingExternalTourType => {
  return TOUR_TYPE_DISPLAY_TO_ENUM[displayValue ?? ''] ?? ListingExternalTourType.ZRM;
};
